"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTHER = exports.DIRECT = exports.YOUTUBE = exports.SOCIAL_MEDIA = exports.OTHER_ORGANIZATION = exports.COURT = exports.LEGAL_AID = exports.ARTICLE = exports.WORD_OF_MOUTH = exports.SEARCH_ENGINE = void 0;
exports.SEARCH_ENGINE = "searchEngine";
exports.WORD_OF_MOUTH = "wordOfMouth";
exports.ARTICLE = "article";
exports.LEGAL_AID = "legalAid";
exports.COURT = "court";
exports.OTHER_ORGANIZATION = "otherOrganization";
exports.SOCIAL_MEDIA = "socialMedia"; // Yelp/Youtube?

exports.YOUTUBE = "youtube"; // Not quite social media and has effort

exports.DIRECT = "direct";
exports.OTHER = "other";